<div class="relative h-[280px]">
    <canvas
        baseChart
        [datasets]="$any(chartDataSets())"
        [labels]="chartLabels()"
        [options]="$any(chartOption)"
        [type]="CHART_TYPE"
        [plugins]="[CENTER_TEXT_PLUGIN, DOUGHNUT_LABEL_LINE]"></canvas>
</div>
